import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { GoogleMapsLink } from '.'
import CopyToClipboard from '../../CopyToClipboard/CopyToClipboard'
import ShipperDocs from './ShipperDocs'

const PickupAddress = ({ shipment, language }) => {

    const [showStopsModal, setShowStopsModal] = useState(false)

    if (shipment) {

        let fullAddress = shipment.shipper.name + " " + shipment.shipper.address.line1
        if (shipment.shipper.address.line2 && shipment.shipper.address.line2 !== "") {
            fullAddress = fullAddress + " " + shipment.shipper.address.line1
        }
        fullAddress = fullAddress + " " + shipment.shipper.address.city + " " + shipment.shipper.address.state + " " + shipment.shipper.address.zip

        return (
            <div>
                <span className='cardBodyRow1 font-weight-bold'>
                    {language && language.code === "es" ? "Recogida:" : "Pickup:"}
                </span><br />
                {shipment.shipper.name}<br />
                {shipment.shipper.address.line1}<br />
                {shipment.shipper.address.line2 && shipment.shipper.address.line2 !== "" ?
                    <>
                        {shipment.shipper.address.line2} <br />
                    </>

                    : null}
                {shipment.shipper.address.city},{" "}
                {shipment.shipper.address.state}{" "}
                {shipment.shipper.address.zip}<br />
                {shipment.customerId.includes("halliburton") && shipment.shipper?.coordinates?.latitude && shipment.shipper?.coordinates?.longitude ?
                    <div>
                        Coordinates: {shipment.shipper.coordinates.latitude}, {shipment.shipper.coordinates.longitude}
                    </div>
                    : null}
                <div className='d-flex'>
                    <CopyToClipboard text={fullAddress} color={"#4c8bf5"} message={'Copied Pickup Address to Clipboard'} />
                    <div className='mr-1'></div>
                    <GoogleMapsLink address={fullAddress} />
                </div>
                {shipment.shipper.contact?.email && shipment.shipper.contact?.email !== "" ? 
                <>
                    <hr/>
                    <a href={`mailto:${shipment.shipper.contact.email}`} data-source="mq.shipemail">{shipment.shipper.contact.email}</a> 
                </> : null}
                <div>
                    <ShipperDocs shipment={shipment} />
                </div>
                {shipment.stops && shipment.stops.length > 2 ? (
                    <button className='mt-2 btn btn-link p-0' onClick={() => { setShowStopsModal(true) }}>
                        Stops ({shipment.stops.length})
                    </button>
                ) : null}

                {shipment.stops && shipment.stops.length > 2 ? (
                    <Modal show={showStopsModal} onHide={() => setShowStopsModal(false)} size="lg">
                        <Modal.Header closeButton>
                            <Modal.Title>Stops ({shipment.stops.length})</Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="cardBodyRow2">
                            {shipment.stops.map((stop, index) => {

                                const humanReadableDate = stop.dates.appointment ? new Date(stop.dates.appointment + 'T00:00:00').toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' }) : null;
                                const appointmentTimeIn = new Date(
                                    `1970-01-01T${stop.dates.appointmentTimeIn}`
                                ).toLocaleTimeString("en-US", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                });
                                const appointmentTimeOut = new Date(
                                    `1970-01-01T${stop.dates.appointmentTimeOUt}`
                                ).toLocaleTimeString("en-US", {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                });

                                const details = [];
                                if (stop?.orders?.length > 0) {
                                    details.push(<>Orders: {stop.orders.map(order => order.usercontrol).join(', ')}</>);
                                }
                                if (stop.bolNotes && stop.bolNotes !== "") {
                                    details.push(<>Notes: {stop.bolNotes}</>);
                                }
                                if (humanReadableDate) {
                                    details.push(
                                        <>
                                            {language && language.code === "es" ? "Cita" : "Appointment"}: {humanReadableDate}
                                            {stop.dates.appointmentTimeIn && stop.dates.appointmentTimeOUt ? (
                                                <> {appointmentTimeIn} - {appointmentTimeOut}</>
                                            ) : null}
                                        </>
                                    );
                                }
                                if (stop.contact.name && stop.contact.name !== "") {
                                    details.push(<>Contact: {stop.contact.name}</>);
                                }
                                if (stop.contact.phone && stop.contact.phone !== "") {
                                    details.push(<>Phone: {stop.contact.phone}</>);
                                }
                                if (stop.contact.email && stop.contact.email !== "") {
                                    details.push(<>Email: {stop.contact.email}</>);
                                }
                                if (stop.contact.fax && stop.contact.fax !== "") {
                                    details.push(<>Fax: {stop.contact.fax}</>);
                                }

                                let stopFullAddress = stop.name + " " + stop.address.line1
                                if (stop.address.line2 && stop.address.line2 !== "") {
                                    stopFullAddress = stopFullAddress + " " + stop.address.line2
                                }
                                stopFullAddress = stopFullAddress + " " + stop.address.city + " " + stop.address.state + " " + stop.address.zip

                                return (
                                    <div key={`stopAddrs-${index}`} className={`d-flex flex-wrap border rounded p-2 ${index > 0 ? "mt-2" : ""}`}>
                                        <div style={{ flex: "1 1 45%", minWidth: "220px" }}>
                                            <span className="font-weight-bold">Stop {index + 1} ({stop.type})</span>
                                            <br />
                                            {stop.name}
                                            <br />
                                            {stop.address.line1}
                                            {stop.address.line2 && stop.address.line2 !== "" ?
                                                <> {stop.address.line2}</>
                                                : null}
                                            <br />
                                            {stop.address.city}, {stop.address.state} {stop.address.zip}
                                            <div className="d-flex mt-1">
                                                <CopyToClipboard text={stopFullAddress} color={"#4c8bf5"} message={`Copied Stop ${index + 1} Address to Clipboard`} />
                                                <div className="mr-1"></div>
                                                <GoogleMapsLink address={stopFullAddress} />
                                            </div>
                                        </div>
                                        <div style={{ flex: "1 1 45%", minWidth: "220px" }}>
                                            {details.map((line, detailIndex) => (
                                                <div className={detailIndex > 0 ? "mt-2" : undefined} key={detailIndex}>
                                                    {line}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                );
                            })}
                        </Modal.Body>
                    </Modal>
                ) : null}
            </div>
        )
    }
    else { return null }
}

export default PickupAddress
